// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__34QC1","vLegacy":"SelectSecondary_vLegacy__2Dgyo","error":"SelectSecondary_error__2jTZq","disabled":"SelectSecondary_disabled__1TLeZ"};